// CRA embeds this browser-visible key at startup/build time. Keep its value in
// a Git-ignored environment file, never in source or a server-side tile proxy.
export function withCartoBasemapKey(tileUrl, apiKey = process.env.REACT_APP_CARTO_BASEMAP_API_KEY) {
  const key = String(apiKey || "").trim();
  if (!key || !/^https:\/\/(?:\{s\}\.|[a-z0-9-]+\.)?basemaps\.cartocdn\.com\//i.test(tileUrl)) {
    return tileUrl;
  }

  // Preserve Leaflet's {s}/{z}/{x}/{y}/{r} placeholders verbatim.
  const hashIndex = tileUrl.indexOf("#");
  const hash = hashIndex < 0 ? "" : tileUrl.slice(hashIndex);
  const url = hashIndex < 0 ? tileUrl : tileUrl.slice(0, hashIndex);
  const queryIndex = url.indexOf("?");
  const path = queryIndex < 0 ? url : url.slice(0, queryIndex);
  const params = new URLSearchParams(queryIndex < 0 ? "" : url.slice(queryIndex + 1));
  params.set("key", key);
  return `${path}?${params.toString()}${hash}`;
}
